import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _PhysicalTakingItemCatalog } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectFixedAsset } from "../../../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/FixedAsset/SelectFixedAsset";
import { EditorFixedAssetItem } from "../../../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/EditorFixedAssetItem";
import { AccountEditor } from "../../../../editor/AccountEditor";
import usePaginator from "../../../../theme/Component/usePaginator";
import { PhysicalTakingConstantsSelect } from "../PhysicalTakingConstantsSelect";
import { BasicButton } from "../../../../theme/Component/BasicButton";
interface Props {
    idPhysicalTaking: number;
}


export const PhysicalTakingItemCatalog = ({ idPhysicalTaking }: Props) => {

    const PhysicalTakingItemCatalog = useDataBean(_PhysicalTakingItemCatalog);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [FixedAsset, setFixedAsset] = useState<any>(null)
    const [FixedAssetitem, setFixedAssetitem] = useState<any>(null)
    const [Account, setAccount] = useState<any>(null)
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const [State, setState] = useState<any>(null)
    const [records, setRecords] = useState<number>(15);
    const [ticketCode, setticketCode] = useState<any>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idPhysicalTaking, paginador.page])

    const getLista = () => {

        PhysicalTakingItemCatalog.instance.getPhysicalTakingItemCatalog(idPhysicalTaking, FixedAsset, FixedAssetitem, Account, regexStr, ticketCode, State, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    //console.log(resp.NumberOfPages)
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)

                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        PhysicalTakingItemCatalog.setBean({
            IDPhysicalTaking: idPhysicalTaking
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        PhysicalTakingItemCatalog.deleteItemVoid(PhysicalTakingItemCatalog.bean.IDItem).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        PhysicalTakingItemCatalog.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDItem', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Placa', property: 'TicketCode', visible: true },
        { title: 'Línea de Activos', property: 'FixedAssetLineName', visible: true },
        { title: 'Clase', property: 'BrandStrName', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Observaciones', property: 'Observations', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${PhysicalTakingItemCatalog.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Consultar Registro de Toma Física de Activos Fijos">
            <div className="row">
                <div className="col-md-4">
                    <SelectFixedAsset idSelector={FixedAsset} onChange={(e) => { setFixedAsset(e) }} />
                </div>
                <div className="col-md-4">
                    <EditorFixedAssetItem idSelector={FixedAssetitem} label="Item de Activo fijo" onChange={(e) => { setFixedAssetitem(e.IDItem) }} />
                </div>
                <div className="col-md-4">
                    <AccountEditor label="Responsable" idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }}></AccountEditor>
                </div>
                <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-4">
                    <label>Placa</label>
                    <input type="text" name="ticketCode" className="form-control" value={ticketCode} onChange={(e) => { setticketCode(parseFloat(e.target.value)) }} />
                </div>
                <div className="col-md-4">
                    <PhysicalTakingConstantsSelect idSelector={State} onChange={(e) => { setState(e) }} />
                </div>
                <div className="col-md-4 mt-4">
                    <BasicButton value="BUSCAR" icon="ri-file-add-line" eventClick={getLista} ></BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={PhysicalTakingItemCatalog.setBean} next={paginador.next}
                        pageTop={paginador.page}
                        back={paginador.back}
                        records={paginador}
                        customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {PhysicalTakingItemCatalog.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}